import { Options } from '../types';

import { DEFAULT_MAX_STEP_SIZE_FOR_CLOUD_RUNNERS } from './const';

export function choiceWord(choices: string[]): string {
  if (choices.length === 1) {
    return '';
  }
  if (choices.length === 2) {
    return 'either ';
  }
  return 'one of ';
}

export function joinChoices(choices: string[]): string {
  let joined = '';
  if (choices.length > 1) {
    joined = choices.slice(0, choices.length - 1).join(', ');
    joined += ' or ';
  }
  joined += choices[choices.length - 1];
  return joined;
}

export function getEffectiveMaxAllowedSizeForCloudRunners(
  options?: Options
): number {
  const maximumAllowedStepSizeForCloudRunners =
    options?.maximumAllowedStepSizeForCloudRunners ??
    DEFAULT_MAX_STEP_SIZE_FOR_CLOUD_RUNNERS;

  return Math.max(
    maximumAllowedStepSizeForCloudRunners,
    DEFAULT_MAX_STEP_SIZE_FOR_CLOUD_RUNNERS
  );
}

export function getAllowedSizes(maxAllowedSize: number): string[] {
  const sizes: number[] = [];
  for (let i = 0; Math.pow(2, i) <= maxAllowedSize; i++) {
    sizes.push(Math.pow(2, i));
  }
  return sizes.map(size => `${size}x`);
}
